<style lang="scss" src="./style.scss" scoped></style>
<script src="./script"></script>
<template>
  <div class="page">
    <div class="page-body p-3">
      <div class="row">
        <div class="col col-12 col-lg-5 mb-3">
          <statistic-cpd></statistic-cpd>
        </div>
        <div class="col col-12 col-lg-7 mb-3">
          <expiration-soon></expiration-soon>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col col-12 col-lg-6 mb-3">
          <cost-by-brand></cost-by-brand>
        </div>
        <div class="col col-12 col-lg-6 mb-3">
          <cost-by-partner></cost-by-partner>
        </div>
      </div>
    </div>
</div>
</template>